module.exports = __webpack_public_path__ + "img/pos1_banner.fa48c17b.png";